"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CodedError = exports.BitErrorCode = exports.BitSubAccountErrorCode = exports.BitIndexerErrorCode = void 0;
var BitIndexerErrorCode;
(function (BitIndexerErrorCode) {
    BitIndexerErrorCode[BitIndexerErrorCode["Error500"] = 500] = "Error500";
    BitIndexerErrorCode[BitIndexerErrorCode["ParamsInvalid"] = 10000] = "ParamsInvalid";
    BitIndexerErrorCode[BitIndexerErrorCode["MethodNotExist"] = 10001] = "MethodNotExist";
    BitIndexerErrorCode[BitIndexerErrorCode["DbError"] = 10002] = "DbError";
    BitIndexerErrorCode[BitIndexerErrorCode["AccountFormatInvalid"] = 20006] = "AccountFormatInvalid";
    BitIndexerErrorCode[BitIndexerErrorCode["AccountNotExist"] = 20007] = "AccountNotExist";
})(BitIndexerErrorCode = exports.BitIndexerErrorCode || (exports.BitIndexerErrorCode = {}));
var BitSubAccountErrorCode;
(function (BitSubAccountErrorCode) {
    BitSubAccountErrorCode[BitSubAccountErrorCode["PermissionDenied"] = 30011] = "PermissionDenied";
})(BitSubAccountErrorCode = exports.BitSubAccountErrorCode || (exports.BitSubAccountErrorCode = {}));
var BitErrorCode;
(function (BitErrorCode) {
    BitErrorCode[BitErrorCode["UnsupportedEVMChainId"] = 1000] = "UnsupportedEVMChainId";
    BitErrorCode[BitErrorCode["SubAccountStatusInvalid"] = 1001] = "SubAccountStatusInvalid";
    BitErrorCode[BitErrorCode["SubAccountDoNotSupportSubAccount"] = 1002] = "SubAccountDoNotSupportSubAccount";
    BitErrorCode[BitErrorCode["SignerRequired"] = 1003] = "SignerRequired";
    BitErrorCode[BitErrorCode["BitBuilderRequired"] = 1004] = "BitBuilderRequired";
    BitErrorCode[BitErrorCode["InvalidAccountId"] = 1005] = "InvalidAccountId";
})(BitErrorCode = exports.BitErrorCode || (exports.BitErrorCode = {}));
class CodedError extends Error {
    constructor(message, code) {
        super(code ? `${code}: ${message}` : message);
        this.code = code;
    }
}
exports.CodedError = CodedError;
//# sourceMappingURL=CodedError.js.map